/**
 * This is the login controller.
 * @memberOf Login Module
 * @namespace Login Controller
 */

/**
 * @name loginController
 * @desc Create the controller.
 * @param loginService
 * @memberOf Login Module.Login Controller
 * @ngInject
 */
function loginController(loginService) {

    // Assign this controller as the view-model.
    // It will be accessible as 'loginController' within the HTML template.
    var vm = this;

    // Register the view model's properties.

    // Activate the controller.
    activate();

    // Activates the controller.
    function activate() {
    }
}

export default loginController;



// WEBPACK FOOTER //
// ./src/login/login.controller.js